// src/layouts/PublicLayout.jsx
import React from "react";
import { useLocation } from "react-router-dom";




const PublicLayout = ({ children }) => {
    const location = useLocation();
    const hideNavbar = location.pathname.includes("/property/");
    return (
        <div className={`min-h-screen flex flex-col ${hideNavbar ? 'bg-white' : 'bg-gray-100'}`}>
            {!hideNavbar && (
                <header className="bg-white shadow p-4">
                    <div className="max-w-4xl mx-auto text-xl font-bold text-blue-600">
                        osm-calendar
                    </div>
                </header>
            )}
            <main className="flex-grow p-4">
                <div className="max-w-7xl mx-auto">{children}</div>
            </main>
            {!hideNavbar && (
                <footer className="text-center text-sm text-gray-400 py-4">
                    © {new Date().getFullYear()} osm-calendar
                </footer>
            )}
        </div>
    );
};

export default PublicLayout;
